export const getCategories = (state) => (type) => {
  return type === 'main'
    ? state.mainCategories
    : type === 'sub-main'
    ? state.subMainCategories
    : state.subCategories
}
